import { useEffect } from "react";
import ApexCharts from "apexcharts";
const PatientChart = ({ perYear }) => {
  useEffect(() => {
    let chart = null;
    const seriesDataHombre = [];
    const seriesDataMujer = [];

    if (perYear && Object.keys(perYear).length > 0) {
      for (const year in perYear) {
        const actividadesPorGenero = perYear[year].reduce(
          (acc, curr) => {
            if (curr.genero === "F") {
              acc.mujer++;
            } else if (curr.genero === "M") {
              acc.hombre++;
            }
            return acc;
          },
          { hombre: 0, mujer: 0 }
        );
        seriesDataHombre.push(actividadesPorGenero.hombre);
        seriesDataMujer.push(actividadesPorGenero.mujer);
      }
    }

    const sColStackedOptions = {
      chart: {
        height: 290,
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "15%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      series: [
        {
          name: "Hombre",
          color: "#2E37A4",
          data: seriesDataHombre,
        },
        {
          name: "Mujer",
          color: "#00D3C7",
          data: seriesDataMujer,
        },
      ],
      xaxis: {
        categories: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
      },
    };

    if (document.querySelector("#patient-chart")) {
      if (!chart) {
        chart = new ApexCharts(
          document.querySelector("#patient-chart"),
          sColStackedOptions
        );

        chart.render();
      }
    }

    return () => {
      if (chart) {
        chart.destroy();
        chart = null;
      }
    };
  }, [perYear]);

  return <div id="patient-chart"></div>;
};

export default PatientChart;
